export default __webpack_public_path__ + "static/media/DictaBook.3e1a9e810558ecd95ea2debd04e93700.webp";